import type { Types } from '../model';

export const useCompanyApi = () => {
  const { $jsonApi } = useNuxtApp();

  const fetch = () => {
    return $jsonApi.prefix('api').all('company').get<Types.ICompany>({
      include:
        'main_custom_page,favicon,domain,seo,communication_channel_operators,communication_channels,header_custom_page,footer_custom_page,auth_methods,modules',
    });
  };

  const update = (company: Partial<Types.ICompany>) => {
    return $jsonApi.prefix('api').all('company').patch<Types.ICompany>(company);
  };

  const fetchSeo = (pageId?: string) => {
    return $jsonApi
      .prefix('api')
      .all('company')
      .get<Types.ICompany>({
        include: 'seo',
        ...(pageId ? { 'filters[seo][page_id]': pageId } : {}),
      });
  };

  return { fetch, update, fetchSeo };
};
